import { render, staticRenderFns } from "./ReportCardAdditionalInfosDriver.vue?vue&type=template&id=6b8cf874&scoped=true&"
import script from "./ReportCardAdditionalInfosDriver.vue?vue&type=script&lang=ts&"
export * from "./ReportCardAdditionalInfosDriver.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8cf874",
  null
  
)

export default component.exports